import React from 'react';
import { testimonials } from '../../data/curly';
export function TestimonialsSection() {
  const featured = testimonials.find(item => item.featured) ?? testimonials[0];
  const rest = testimonials.filter(item => item !== featured);
  return <section className="border-b border-white/5 bg-cocoa py-20" aria-labelledby="testimonials-title" data-id="element-139" data-mp="3cz1fohk6tq6b">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-140" data-mp="3hv8qannj3pul">
        <h2 id="testimonials-title" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-141" data-mp="2kacfqluvbqw5">
          Lo que cambió para ellas
        </h2>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.4fr_1fr] lg:gap-12" data-id="element-142" data-mp="2p6kzkck0g89n">
          <figure className="flex h-full flex-col border-l-2 border-gold pl-6" data-id="element-143" data-mp="2u65ywo33eimw">
            <blockquote className="font-display text-2xl italic leading-snug text-cream sm:text-3xl" data-id="element-144" data-mp="2yzilyts4ihdj">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-6 text-sm text-sand" data-id="element-145" data-mp="26i6a3tpcd2ay">
              <span className="font-semibold text-cream" data-id="element-146" data-mp="26gboed68x65t">{featured.name}</span> · {featured.detail}
            </figcaption>
          </figure>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-1" data-id="element-147" data-mp="813sbpixs6al">
            {rest.map(item => <figure key={item.name} className="flex h-full flex-col border-t border-white/10 pt-5" data-id="element-148" data-mp="39lngqdsllkc">
                <blockquote className="leading-relaxed text-sand" data-id="element-149" data-mp="3vefugxunfeuv">“{item.quote}”</blockquote>
                <figcaption className="mt-auto pt-4 text-sm text-sand/80" data-id="element-150" data-mp="3qfcmb4jdgsio">
                  <span className="font-semibold text-cream" data-id="element-151" data-mp="3qcgrhp2tmjyg">{item.name}</span> · {item.detail}
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}